<kendo-toolbar>

    <kendo-toolbar-dropdownbutton
      text="Menu"
      [data]="GetMenuItems()"
      [icon]="icon"
      (itemClick)="HandleMenuClick($event)"
    ></kendo-toolbar-dropdownbutton>
  <kendo-toolbar-separator></kendo-toolbar-separator>

  <kendo-toolbar-button   text="Clients" icon="detail-section" [primary]="true" (click)="navigate('list')"> </kendo-toolbar-button>>

  <kendo-toolbar-button   text="logout" icon="logout" [primary]="true" (click)="auth.logout({ returnTo: document.location.origin })"> </kendo-toolbar-button>>
  <kendo-toolbar-button  [disabled]="true" text="{{ url.GetCurrentClient() }}"></kendo-toolbar-button>
  <kendo-toolbar-separator></kendo-toolbar-separator>
  <kendo-toolbar-separator></kendo-toolbar-separator>


<!--  <kendo-toolbar-button *ngIf="auth.user$ | async as user"  [disabled]="true" text="{{ user.name }}"></kendo-toolbar-button>-->
<!--  <kendo-toolbar-button *ngIf="auth.user$ | async as user"  [disabled]="true" text="{{ user.email }}"></kendo-toolbar-button>-->

</kendo-toolbar>

